/* eslint-disable no-magic-numbers */
const URL = "/getData.php";

function getUrl(inputUrl: string) {
	return `${URL}?path=${encodeURIComponent(inputUrl)}`;
}

function generateList({ title, cover, seo, src, count }) {
	const list = {
		title,
		cover,
		seo,
		alt: title,
		imgs: [],
		type: "fotky",
	};

	for (let ind = 1; ind <= count; ind++) {
		list.imgs.push({
			seo: ind,
			src: getUrl(`${src}-${ind < 10 ? "0" : ""}${ind}.jpg`),
			largeSrc: getUrl(`${src}-${ind < 10 ? "0" : ""}${ind}-large.jpg`),
			alt: title,
		});
	}

	return list;
}

export function getPhotoData() {
	const photoData = [];

	photoData.push(generateList({
		title: "Porodnice",
		cover: getUrl("/martinek-photos/porodnice-08.jpg"),
		seo: "porodnice",
		src: "/martinek-photos/porodnice",
		count: 22,
	}));

	photoData.push(generateList({
		title: "První týden",
		cover: getUrl("/martinek-photos/tyden-01-03.jpg"),
		seo: "tyden-01",
		src: "/martinek-photos/tyden-01",
		count: 31,
	}));

	photoData.push(generateList({
		title: "Focení",
		cover: getUrl("/martinek-photos/foceni-2021-01.jpg"),
		seo: "foceni-2021",
		src: "/martinek-photos/foceni-2021",
		count: 53,
	}));

	photoData.push(generateList({
		title: "Vánoce 2021",
		cover: getUrl("/martinek-photos/vanoce-2021-05.jpg"),
		seo: "vanoce-2021",
		src: "/martinek-photos/vanoce-2021",
		count: 25,
	}));

	photoData.push(generateList({
		title: "Druhý měsíc",
		cover: getUrl("/martinek-photos/mesic-01-04.jpg"),
		seo: "mesic-01",
		src: "/martinek-photos/mesic-01",
		count: 34,
	}));

	photoData.push(generateList({
		title: "Třetí měsíc",
		cover: getUrl("/martinek-photos/mesic-02-01.jpg"),
		seo: "mesic-02",
		src: "/martinek-photos/mesic-02",
		count: 21,
	}));

	photoData.push(generateList({
		title: "Čtvrtý měsíc",
		cover: getUrl("/martinek-photos/mesic-03-01.jpg"),
		seo: "mesic-03",
		src: "/martinek-photos/mesic-03",
		count: 56,
	}));

	photoData.push(generateList({
		title: "Pátý měsíc",
		cover: getUrl("/martinek-photos/mesic-04-01.jpg"),
		seo: "mesic-04",
		src: "/martinek-photos/mesic-04",
		count: 30,
	}));

	photoData.push(generateList({
		title: "Šestý měsíc",
		cover: getUrl("/martinek-photos/mesic-05-01.jpg"),
		seo: "mesic-05",
		src: "/martinek-photos/mesic-05",
		count: 29,
	}));

	photoData.push(generateList({
		title: "Sedmý měsíc",
		cover: getUrl("/martinek-photos/mesic-06-01.jpg"),
		seo: "mesic-06",
		src: "/martinek-photos/mesic-06",
		count: 51,
	}));

	photoData.push(generateList({
		title: "Dovolená Itálie",
		cover: getUrl("/martinek-photos/mesic-06-dov-01.jpg"),
		seo: "dovolena-italie-2021",
		src: "/martinek-photos/mesic-06-dov",
		count: 28,
	}));

	photoData.push(generateList({
		title: "Osmý měsíc",
		cover: getUrl("/martinek-photos/mesic-07-01.jpg"),
		seo: "mesic-07",
		src: "/martinek-photos/mesic-07",
		count: 53,
	}));

	// Šestý měsíc je od 11.5.. 11.6. začíná sedmý

	photoData.reverse();

	return photoData;
}
